export default __webpack_public_path__ + "static/media/bg.8616b030.png";